/**
 * Admin Route - Minting Dapps Management
 *
 * Route: /admin/minting-dapps
 *
 * Provides administrative interface for managing registered minting dapps.
 * Requires admin permissions (bmp bit 7 set).
 *
 * @module routes/admin/minting-dapps
 * @category Admin Routes
 */

import { createFileRoute } from '@tanstack/react-router';
import AdminMintingDappsContainer from '@/containers/AdminMintingDapps';
import { get_permissions } from '@/utils';

// Protected route - will check permissions in component
export const Route = createFileRoute('/$locale/admin/minting-dapps')({
  component: AdminMintingDappsPage,
});

function AdminMintingDappsPage() {
  // Check admin permissions
  const isAdmin = get_permissions?.('admin') || false;

  // Redirect non-admins
  if (!isAdmin) {
    return (
      <>
        <div className="main-content mt-1 border-radius-lg">
          <div className="container-fluid py-5">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="card border-0 shadow">
                  <div className="card-body text-center p-5">
                    <i className="fas fa-lock fa-4x text-danger mb-4"></i>
                    <h3 className="text-dark mb-3">Access Denied</h3>
                    <p className="text-muted mb-4">
                      You don't have permission to access the admin panel.
                      This area is restricted to administrators only.
                    </p>
                    <a href="/" className="btn btn-primary">
                      <i className="fas fa-home me-2"></i>
                      Go to Homepage
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="main-content position-relative bg-gradient-dark" style={{ minHeight: 'calc(100vh - 56px)' }}>
        <div className="container-fluid py-4">
          <AdminMintingDappsContainer />
        </div>
      </div>
    </>
  );
}
